import { render } from "./GlobalMenuButton.vue?vue&type=template&id=d380971a&scoped=true"
import script from "./GlobalMenuButton.vue?vue&type=script&lang=js"
export * from "./GlobalMenuButton.vue?vue&type=script&lang=js"

import "./GlobalMenuButton.vue?vue&type=style&index=0&id=d380971a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d380971a"]])

export default __exports__